import React, { useState } from "react";
import SummaryApi from "../common/index";
import { useNavigate } from "react-router-dom"; // for navigation
import Cookies from "js-cookie"; // to handle cookies
import CustomDialog from "./CustomDialog";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaYoutube,
  FaTwitter,
  FaWhatsapp,
} from "react-icons/fa";
const ContactForm = () => {
  const [studentName, setStudentName] = useState("");
  const [studentNumber, setStudentNumber] = useState("");
  const [parentName, setParentName] = useState("");
  const [parentNumber, setParentNumber] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [isError, setIsError] = useState(false);
  const [isDialogVisible, setIsDialogVisible] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const navigate = useNavigate(); // useNavigate for navigation
  const [isValidPhone, setIsValidPhone] = useState(true);
  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    if (value.length <= 10) {
      setStudentNumber(value);
    }
  };
  const validatePhoneNumber = () => {
    const cleanedNumber = studentNumber.replace(/[^0-9]/g, "");
    if (cleanedNumber.length !== 10) {
      setIsValidPhone(false);
      //alert("Please enter exactly 10 digits for the phone number.");
      return false;
    }
    setIsValidPhone(true);
    return true;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Ensure the phone numbers are exactly 10 digits
    // if (!validatePhoneNumber()) {
    //   setDialogMessage("Please enter exactly 10 digits for the phone number.");
    //   setIsDialogVisible(true);
    //   return; // Stop submission if phone number is invalid
    // }
    if (!validatePhoneNumber()) {
      alert("Please enter exactly 10 digits for the phone number.");
      return; // Stop submission if phone number is invalid
    }
    if (!selectedCourse) {
      setIsError(true); // Show error if no course is selected
      return;
    } else {
      setIsError(false); // Clear error if a course is selected
    }
    const payload = {
      student_name: studentName,
      mobile_number: studentNumber.replace(/[^0-9]/g, ""),
      parent_name: parentName,
      email: email,
      address: address,
      course: selectedCourse,
    };
    // Show success dialog
    setDialogMessage("Our Team will Contact You Soon.");
    setIsDialogVisible(true);
    // Reset form fields after submission
    setStudentName("");
    setStudentNumber("");
    setParentName("");
    setParentNumber("");
    setEmail("");
    setAddress("");
    setSelectedCourse("");
    try {
      const response = await fetch(SummaryApi.createContact.url, {
        method: SummaryApi.createContact.method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      if (data.student_id) {
        Cookies.set("student_id", data.student_id, { expires: 7 });
        const message = `
          *Enrollment Form Details:*
          *Student Name:* ${studentName}
          *Student Number:* ${studentNumber}
          *Email:* ${email}
          *Address:* ${address}
          *Selected Course:* ${selectedCourse}
        `;
        const encodedMessage = encodeURIComponent(message);
        const whatsappNumber = "+918919311981";
        const whatsappURL = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
        window.location.href = whatsappURL;
        navigate("/");
      }
    } catch (error) {
      console.error("Error during registration:", error);
    }
  };
  const closeDialog = () => {
    setIsDialogVisible(false);
  };
  return (
    <div
      className="flex flex-col md:flex-row bg-white p-6 md:p-12 rounded-lg shadow-lg w-full max-w-4xl mx-auto mt-10 mb-10 bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${require("../Assets/Conatct1.png")})` }}
    >
      <div className="md:w-2/3 p-6">
        <h2 className="text-2xl font-bold text-[#FF7F50] mb-4">Contact Us</h2>
        {/* <p className="text-gray-600 mb-6">
          Feel free to contact us any time. We will get back to you as soon as
          we can!
        </p> */}
        {isDialogVisible && (
          <CustomDialog message={dialogMessage} onClose={closeDialog} />
        )}
        <form className="flex flex-col space-y-4" onSubmit={handleSubmit}>
          <div className="flex flex-col sm:flex-row sm:space-x-4 sm:space-y-0 space-y-4">
            <input
              type="text"
              value={studentName}
              onChange={(e) => setStudentName(e.target.value)}
              placeholder="Student Name"
              className="p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-400 w-full sm:w-auto"
            />
            <input
              type="tel"
              value={studentNumber}
              onChange={handlePhoneChange}
              onBlur={validatePhoneNumber}
              style={{
                border: `1px solid ${isValidPhone ? "#D1D5DB" : "#F87171"}`,
              }}
              placeholder="Student Number"
              className="p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-400 w-full sm:w-auto"
            />
          </div>
          <div className="flex flex-col sm:flex-row sm:space-x-4 sm:space-y-0 space-y-4">
            <input
              type="text"
              value={parentName}
              onChange={(e) => setParentName(e.target.value)}
              placeholder="Parent Name"
              className="p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-400 w-full sm:w-auto"
            />
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              className="p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-400 w-full sm:w-auto"
            />
          </div>
          <textarea
            placeholder="Address"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            rows="4"
            className="p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-400 w-full"
          ></textarea>
          <select
            value={selectedCourse}
            onChange={(e) => setSelectedCourse(e.target.value)}
            className="w-full border border-gray-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500 p-3"
          >
            <option value="" disabled>
              -- Select a Course --
            </option>
            <option value="ARTIFICIAL INTELLIGENCE AND MACHINE LEARNING">
              ARTIFICIAL INTELLIGENCE AND MACHINE LEARNING
            </option>
            <option value="COMPUTER SCIENCE & ENGINEERING">
              COMPUTER SCIENCE & ENGINEERING
            </option>
            <option value="ELECTRONICS & COMMUNICATION ENGINEERING">
              ELECTRONICS & COMMUNICATION ENGINEERING
            </option>
            <option value="CIVIL ENGINEERING">CIVIL ENGINEERING</option>
            <option value="ELECTRICAL & ELECTRONICS ENGINEERING">
              ELECTRICAL & ELECTRONICS ENGINEERING
            </option>
            <option value="MECHANICAL ENGINEERING">
              MECHANICAL ENGINEERING
            </option>
            <option value="CLOUD COMPUTING & BIG DATA">
              CLOUD COMPUTING & BIG DATA
            </option>
          </select>
          <button
            type="submit"
            className="bg-[#FF7F50] text-white p-3 rounded-lg hover:bg-gray-800"
          >
            SUBMIT
          </button>
        </form>
      </div>
      <div className="flex flex-col">
        <div
          className="md:w-50 bg-[#FF7F50] text-white p-3 rounded-lg  flex flex-col
       justify-between max-h-[500px] mt-0 md:mt-[40%] mb-[5%] md:mb-[30%]"
        >
          <h3 className="text-lg font-bold mb-4">Info</h3>
          <div className="space-y-4">
            <p className="flex items-center gap-2">
              <span>&#9993;</span> srijyothipolytechnic@gmail.com
            </p>
            <p className="flex items-center gap-2">
              <span>&#9742;</span>08676-283921, 9390019382, 6304732269
            </p>
            <p className="flex items-center gap-2">
              <span>&#127970;</span> Sri Jyothi Polytechnic ,
              Kalavapamula-521164, Vuyyuru Mandal, Krishna Dist., Andhra
              Pradesh, India
            </p>
            <p className="flex items-center gap-2">
              <span>&#9200;</span> 09:00 AM - 06:00 PM
            </p>
          </div>
        </div>
        <div className="flex flex-wrap gap-2 justify-center ml-0 md:ml-[95%]">
          <div className="flex gap-2 justify-center">
            <a
              href="https://www.facebook.com/srijyothi.polytechnic"
              className="flex items-center space-x-2 hover:text-gray-400"
            >
              <FaFacebook className="text-blue-600 text-xl" />
            </a>
            <a
              href="https://www.instagram.com/srijyothipolytechnic451?igsh=bmh1dzdzeGIxY25i"
              className="flex items-center space-x-2 hover:text-gray-400"
            >
              <FaInstagram className="text-pink-600 text-xl" />
            </a>
            <a
              href="https://www.linkedin.com/company/sri-jyothi-polytechnic/"
              className="flex items-center space-x-2 hover:text-gray-400"
            >
              <FaLinkedin className="text-blue-700 text-xl" />
            </a>
          </div>
          <div className="flex gap-2 justify-center mt-0 md:mt-[5%]">
            <a
              href="https://youtu.be/CDDqFLaSIl8?si=GiynOPHWtwH6MNJX"
              className="flex items-center space-x-2 hover:text-gray-400"
            >
              <FaYoutube className="text-red-600 text-xl" />
            </a>
            <a
              href="https://twitter.com"
              className="flex items-center space-x-2 hover:text-gray-400"
            >
              <FaTwitter className="text-blue-500 text-xl" />
            </a>
            <a
              href="https://wa.me/919390019382"
              className="flex items-center space-x-2 hover:text-gray-400"
            >
              <FaWhatsapp className="text-green-500 text-xl" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ContactForm;
